<template>
    <div>
        <NavEnvBlock
            v-for="envitem in envpagedata"
            v-bind:envitem="envitem"
            v-on:click.native="selectEnvirements(envitem.id)"
        />
    </div>
</template>
<script>

    import NavEnvBlock from '@/components//NavEnvBlock.vue'

    export default {
        props: ['envpagedata'],
        data() {
            return {

            }
        },
        mounted() {

        },
        components:{
            NavEnvBlock
        },
        methods: {
            selectEnvirements(id) {
                this.$emit('selectEnvirements', id)
            },
        }

    }
</script>